import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Config } from "./config";
import { environment } from '../../environments/environment';

import { map, catchError, finalize } from 'rxjs/operators';
//import { Loading } from '../components/widget/widget.loading.component';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';

const API_URL = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    private _requestCnt = 0;
    public requestCntObserver = new BehaviorSubject(this._requestCnt);

    constructor(
        private http: HttpClient,
        private config: Config,
        private router: Router) { 
            this.router.events.subscribe((ev) => {
                if(ev instanceof NavigationEnd) {
                    this.requestCnt = 0;
                }
            })
        }

    public addRequestCnt(): void {
        this.requestCnt++;
    }

    public subtractRequestCnt(): void {
        this.requestCnt--;
    }

    private set requestCnt(val) {
        this._requestCnt = val;
        this.requestCntObserver.next(this._requestCnt);
        if(this._requestCnt<0) this._requestCnt = 0;
    }

    private get requestCnt() {
        return this._requestCnt
    }

    public get(url: string, params?: any , responseType:String = 'json' ) {
        if (responseType == 'blob'){
            return this.http.get(API_URL + url, {headers: this.config.HEADER, params: params,responseType: 'blob'});
        }
        return this.http.get<any>(API_URL + url, {headers: this.config.HEADER, params: params });
    }

    public post(url: string, params: any) {
        console.log("HttpService POST", API_URL + url);
        return this.http.post<any>(API_URL + url, params, { headers: this.config.HEADER });
    }

    public put(url: string, params: any) {
        return this.http.put<any>(API_URL + url, params, { headers: this.config.HEADER });
    }

    public delete(url: string) {
        return this.http.delete<any>(API_URL + url, { headers: this.config.HEADER });
    }

    public mock(url) {
        return this.http.get<any>(API_URL + url);
    }
    
    public upload(data: any) {
        let url = '/upload';
        return this.http.post<any>(API_URL + url, data, {});
    }
}
